import { FlexBox, IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { useEffect, useState } from 'react';
import { useCopyToClipboard } from 'react-use';

type WebformEndpointsTableActionsProps = {
  endpointUrl: string;
  handleDeleteWebformEndpoint: () => void;
};

export const WebformEndpointsTableActions = ({
  endpointUrl,
  handleDeleteWebformEndpoint,
}: WebformEndpointsTableActionsProps): JSX.Element => {
  const [_, copyToClipboard] = useCopyToClipboard();
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    const timeoutId = isCopied
      ? window.setTimeout(() => setIsCopied(false), 3000)
      : undefined;
    return () => window.clearTimeout(timeoutId);
  }, [isCopied]);

  return (
    <FlexBox flexDirection="row">
      <Tooltip content={isCopied ? 'Copied' : 'Copy URL'}>
        <IconButton
          variant="tertiary"
          icon={isCopied ? 'done' : 'copy'}
          onClick={() => {
            copyToClipboard(endpointUrl);
            setIsCopied(true);
            ampli.settingsIntegrationsWebformEndpointsCopy();
          }}
        />
      </Tooltip>
      <Tooltip content="Delete">
        <IconButton
          variant="tertiary"
          icon="trash"
          onClick={handleDeleteWebformEndpoint}
        />
      </Tooltip>
    </FlexBox>
  );
};
